import * as customTypes from "@/domains/profile/constants/custom-types";
import * as systemTypes from "@/domains/profile/constants/system-types";

import * as FileFormatter from "./file";
import * as TextFormatter from "./text";

import * as FullNameFormatter from "./full-name";
import * as CitizenshipFormatter from "./citizenship";
import * as SkillsFormatter from "./skills";
import * as CareerFormatter from "./career";
import * as AdditionalEducationFormatter from "./additional-education";
import * as PersonalDataFormatter from "./personal-data";

export const customFormatters = {
    [customTypes.FIELD_TYPE_FILE]: FileFormatter,
    [customTypes.FIELD_TYPE_TEXT]: TextFormatter,
};

export const systemFormatters = {
    [systemTypes.FIELD_TYPE_FULL_NAME]: FullNameFormatter,
    [systemTypes.FIELD_TYPE_CITIZENSHIP]: CitizenshipFormatter,
    [systemTypes.FIELD_TYPE_SKILLS]: SkillsFormatter,
    [systemTypes.FIELD_TYPE_CAREER]: CareerFormatter,
    [systemTypes.FIELD_TYPE_ADDITIONAL_EDUCATION]: AdditionalEducationFormatter,
    [systemTypes.FIELD_TYPE_PERSONAL_DATA]: PersonalDataFormatter,
};

export function getFieldFormatter(isSystem, fieldType) {
    return isSystem ? systemFormatters[fieldType] : customFormatters[fieldType];
}
